import React, { useState, useEffect, useRef } from "react";
import styles from './Jeemocktest.module.css'
import Step1Img from '../../assets/jee_step_1.svg'
import Step1ImgM from '../../assets/jee_step_1.svg'
import Step2Img from '../../assets/jee_step_2.svg'
import Step2ImgM from '../../assets/jee_step_2.svg'
import Step3Img from '../../assets/jee_step_3.svg'
import Step3ImgM from '../../assets/jee_step_3.svg'

const steps = [
    {
        number: "01",
        title: "Verify your mobile number",
        description: "Ensure security by entering the OTP sent to your phone.",
        image: Step1Img,
        mweb: Step1ImgM
    },
    {
        number: "02",
        title: "Submit your details",
        description: "Fill in the necessary information to personalize your account.",
        image: Step2Img,
        mweb: Step2ImgM
    },
    {
        number: "03",
        title: "Registration completed",
        description: "You’re all set! Start exploring right away.",
        image: Step3Img,
        mweb: Step3ImgM
    }
];

const JeeHowRegister = () => {
    const [visibleIndex, setVisibleIndex] = useState(-1);
    const stepsRef = useRef(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
    
        // Add event listener on mount
        window.addEventListener("resize", handleResize);
    
        return () => {
            // Cleanup event listener on unmount
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && visibleIndex === -1) {
                    setVisibleIndex(0);
                }
            },
            { threshold: 0.5 }
        );

        if (stepsRef.current) observer.observe(stepsRef.current);

        return () => observer.disconnect();
    }, [visibleIndex]);

    useEffect(() => {
        if (visibleIndex < steps.length - 1 && visibleIndex !== -1) {
            const timer = setTimeout(() => {
                setVisibleIndex((prev) => prev + 1);
            }, isMobile ? 3000 : 4000); // Slower on desktop
            return () => clearTimeout(timer);
        } else if (visibleIndex === steps.length - 1) {
            const restartTimer = setTimeout(() => {
                setVisibleIndex(0);
            }, isMobile ? 3000 : 4000);
            return () => clearTimeout(restartTimer);
        }
    }, [visibleIndex, isMobile]);
    
    return (
        <div className='container' id="how-it-works">
            <div className={styles.jee_register_wrapper}>
                <div className={styles.jee_reg_heading}>
                    <h3>Register in just 3 steps</h3>
                    <h6>Here's how</h6>
                </div>
                {/* animation */}
                <div className={styles.jee_register_step} ref={stepsRef}>
                    <div className={styles.step_details_reg}>
                        <div className={styles.reg_steps}>
                            {steps.map((step, index) => (
                                <div
                                    key={index}
                                    className={`${styles.reg_step} ${index === visibleIndex ? styles.active : ""}`}
                                   
                                >
                                    <div className={styles.reg_step_number}>{step.number}</div>
                                    <div>
                                    <h6 style={{ color: visibleIndex === steps.length - 1 ? "black" : "" }}>{step.title}</h6>
                                        <p>
                                            {step.description}
                                            <img src={isMobile ? steps[visibleIndex]?.mweb : ''} alt="" className={`${styles.register_img_mobile} img-fluid`}/></p>
                                       
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={`${styles.jee_register_img} ${styles.d_block}`}>
                        <img src={steps[visibleIndex]?.image} alt="Step" style={{ transition: "opacity 0.7s ease-in-out" }} className="img-fluid"/>
                    </div>
                </div>
                {/* animation */}
            </div>
        </div>
    )
}

export default JeeHowRegister